import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Dropdown from 'flarum/common/components/Dropdown';
import Button from 'flarum/common/components/Button';
import Avatar from 'flarum/common/components/Avatar';
import Link from 'flarum/common/components/Link';
// v0.6.1 — UserNameLink 改用 user.username() 直接读 (避免 username() helper 用 displayName 跟 nickname 重复)
import Api from '../utils/Api';
// v0.8.1 — 卡种背景图 URL 解析 (辉哥 10/6 拍板银行卡背景, 桌面 132×83 / 移动 102×64)
import cardBackgroundStyle from '../utils/CardBackground';
// v0.18.62 — 退费金额展示格式 (千分位 + 两位小数, 整数不带小数; ⛔ 不做任何金额计算)
import { formatAmount } from '../utils/refundFormat';
import BindCardModal from '../modal/BindCardModal';
import ActivateCardModal from '../modal/ActivateCardModal';
import AddStudentModal from '../modal/AddStudentModal';
// v0.6.28 — EditStudentModal (辉哥 9/29 12:55 拍板)
import EditStudentModal from '../modal/EditStudentModal';
// v0.8.1 — CardDetailModal (辉哥拍板 B 方案: 浮层「详情」按钮必须弹 modal)
import CardDetailModal from '../modal/CardDetailModal';
// v0.10.0 — 学员合同 (辉哥 10/8 拍板: 入口只在学员列表, 绑卡弹窗一行不加)
// v0.10.7 — 合同浮层改走 Flarum 原生 Modal, 自绘的 StudentContractPopover 已删除
import StudentContractModal from '../modal/StudentContractModal';
// v0.17.14 — 「上课详情」弹层 (辉哥 10/13 拍板, 决策 A: 复用桌面死按钮 + 移动端第 4 个 chip)
import StudentLessonsModal from '../modal/StudentLessonsModal';
// v0.10.7 — toast 复用本仓既有 SlotContextMenu.toast() (合同 Modal 取消后,
//   本文件 L609 的「请先选择校区」提示不能再挂在已删除的浮层上)
import SlotContextMenu from '../utils/SlotContextMenu';

/**
 * STATS_DEFAULTS — v0.17.24a 新增
 *
 *   this.stats 的**唯一默认值来源** (原先这 5 个字面量只写在 oninit 里, 改口径时容易漏)。
 *
 *   为什么需要它 (v0.17.24 引入的回归根因):
 *     后端 ListStudentsController L31 在无权限时返回 `['students' => [], 'stats' => []]`,
 *     PHP 空数组序列化成 JSON **[]** 而不是 null —— 而 JS 里**空数组是 truthy**,
 *     所以 v0.17.24 那行 `this.stats = (r && r.stats) || this.stats;` 里的 `[] || x` 返回 `[]`,
 *     把 oninit 初始化好的默认值整个冲掉 ⇒ 无 `scheduler.view` / `scheduler.manageStudents`
 *     的用户看到标题变成 `共 {undefined} 人 · {undefined} 张卡片`。
 *     (同样的 [] 也让 filterOptions() 的 count 和 5 张统计卡对无权限用户渲染 undefined。)
 *
 *   修法: 赋值处收口 —— 一律「默认值 + 合并服务端返回」。
 *     Object.assign({}, DEFAULTS, [])  ⇒ DEFAULTS 原样 (空数组没有任何 own enumerable key)
 *     Object.assign({}, DEFAULTS, obj) ⇒ obj 覆盖同名字段
 *     Object.assign({}, DEFAULTS, null/undefined) ⇒ DEFAULTS 原样
 *   ⇒ 任何畸形/空的 stats 都冲不掉默认值, 且修一处同时护住标题 + filterOptions + 统计卡。
 */
const STATS_DEFAULTS = {
  total_students: 0,
  total_cards: 0,
  valid_cards: 0,
  expiring_cards: 0,
  expired_cards: 0
};

/**
 * UserAvatarLink — v0.5.8 新增 (Flarum 原生 Avatar + 跳 profile)
 */
export class UserAvatarLink extends Component {
  view() {
    const userId = this.attrs.userId;
    if (!userId) {
      return m(Avatar, {
        user: null
      });
    }
    let user = app.store.getById('users', userId);
    if (!user) {
      app.store.find('users', userId).catch(() => null);
      return m(Avatar, {
        user: null
      });
    }
    return m("span", {
      className: "ZS-user-avatar-link"
    }, m(Avatar, {
      user: user
    }));
  }
}

/**
 * UserNameLink — v0.5.8 新增
 */
export class UserNameLink extends Component {
  view() {
    const userId = this.attrs.userId;
    if (!userId) {
      return m("span", {
        className: "ZS-student-name-fallback"
      }, "\u672A\u77E5\u7528\u6237");
    }
    const user = app.store.getById('users', userId);
    if (!user) {
      app.store.find('users', userId).catch(() => null);
      return m("span", {
        className: "sc-at ZS-student-name-fallback"
      }, "#", userId);
    }
    return m("span", {
      className: "sc-at"
    }, user.username());
  }
}
export default class StudentsListTab extends Component {
  // v0.8.5 — 统一无限次判定 (辉哥 10/7 拍板, 跟后端 StudentCard::isUnlimited() 口径一致)
  //   改前: L643 L768 各处自己写 `remaining_lessons === -1`, 口径不一致
  //   改后: 走 isUnlimited(card) 方法, 后端改口径前端一处更新即可
  isUnlimited(card) {
    if (!card) return false;
    return card.total_lessons === 0 || card.remaining_lessons === -1;
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.students = [];
    this.stats = Object.assign({}, STATS_DEFAULTS);
    this.loading = true;
    this.filter = 'all';
    this.search = '';
    this.activeSchoolId = vnode.attrs.activeSchoolId;
    this.schools = vnode.attrs.schools || [];
    this.onAddStudentCb = vnode.attrs.onAddStudent;

    // ── v0.18.69 — 「查看学员」跳转带过来的**一次性高亮** (brief §4.2) ──
    //   URL 形如 `/scheduler/students?highlight_student={user_id}`
    //   ⚠️ 读的是 `window.location.search` (不是 attrs) —— 跳转是父组件 replaceState 做的,
    //      本组件拿不到那个值; 直接读 URL 最省事也最不容易失配。
    this.highlightStudentId = this.readHighlightParam();
    this._highlightTimer = null;

    // v0.8.1 — 浮层状态 (辉哥 10/6 拍板 B 方案: 单例浮层挂 body 顶层 + fixed + viewport 坐标)
    //   - 单一 DOM 节点 document.body.appendChild 一次, 全局复用
    //   - position: fixed 脱离祖先 overflow:hidden (V 测发现 .sc-cards / .ZS-student-card-mobile / 桌面行 都裁)
    //   - chip.getBoundingClientRect() 已含滚动偏移, 不用再减 scrollLeft
    //   - 同时只允许一个浮层展开
    //   shape: { kind: 'desktop'|'mobile', cardId }
    this.activeCard = null;
    this._popupEl = null; // 单例浮层 DOM 节点 (lazy create on first show)
    this._popupKind = null; // 'desktop' | 'mobile' | null
    this._docClickHandler = null;
    this._hideTimeout = null;
    this._recalcOnScroll = null;
    this._recalcOnResize = null;
    this._recalcOnCardScroll = null;
    this._activeScrollEl = null;
    this.load();
  }
  onbeforeupdate(vnode) {
    super.onbeforeupdate(vnode);
    if (vnode.attrs.activeSchoolId !== this.activeSchoolId) {
      this.activeSchoolId = vnode.attrs.activeSchoolId;
      this.load();
    }
    this.schools = vnode.attrs.schools || this.schools;
    this.onAddStudentCb = vnode.attrs.onAddStudent || this.onAddStudentCb;
  }
  onremove() {
    this.hideActive();
    // v0.10.7 — 合同改走原生 Modal 后, 原来那句 StudentContractPopover._forceClose()
    //   跟着被删的浮层一起没了。但**孤儿问题本身没消失**: Modal 由 Flarum 的
    //   ModalManager 挂在 ModalManager 层, 不在本组件子树内, 组件销毁不会带走它
    //   —— 用户开着合同弹窗切走路由就会剩一个孤儿弹窗。
    //   所以改成只关**本组件自己开的那一个** (_contractModalOpen 标记),
    //   避免误关别人正在用的弹窗 (app.modal.close() 关的是最上层)。
    if (this._contractModalOpen && app.modal && typeof app.modal.close === 'function') {
      app.modal.close();
      this._contractModalOpen = false;
    }
    if (this._popupEl && this._popupEl.parentNode) this._popupEl.parentNode.removeChild(this._popupEl);
    this._popupEl = null;
    // v0.18.69 — 高亮计时器随组件一起走 (⛔ 不清的话会在组件销毁后再触发一次 redraw)
    if (this._highlightTimer) {
      clearTimeout(this._highlightTimer);
      this._highlightTimer = null;
    }
  }

  // ── v0.8.1 — 浮层控制 (辉哥拍板 B 方案: 单例浮层挂 body 顶层 + fixed + viewport 坐标) ──

  _popupButtonClick(action, card) {
    this.hideActive();
    if (action === 'detail') {
      // v0.8.1 — 弹 CardDetailModal (只读, 不提交)
      app.modal.show(CardDetailModal, {
        card
      });
    } else if (action === 'activate') {
      this.openActivateCard(card);
    } else if (action === 'extend' || action === 'unlock') {
      this.openExtend(card);
    }
  }
  hideActive() {
    if (this._hideTimeout) {
      clearTimeout(this._hideTimeout);
      this._hideTimeout = null;
    }
    this.activeCard = null;
    if (this._popupEl) {
      this._popupEl.style.display = 'none';
      this._popupEl.style.left = '-9999px';
      this._popupEl.style.top = '-9999px';
    }
    this._uninstallRecalcListeners();
    this.detachDocClick();
  }
  _uninstallRecalcListeners() {
    if (this._recalcOnScroll) window.removeEventListener('scroll', this._recalcOnScroll, true);
    if (this._recalcOnResize) window.removeEventListener('resize', this._recalcOnResize);
    if (this._recalcOnCardScroll && this._activeScrollEl) {
      this._activeScrollEl.removeEventListener('scroll', this._recalcOnCardScroll);
    }
    this._recalcOnScroll = this._recalcOnResize = this._recalcOnCardScroll = null;
    this._activeScrollEl = null;
  }
  detachDocClick() {
    if (this._docClickHandler) {
      document.removeEventListener('click', this._docClickHandler, true);
      this._docClickHandler = null;
    }
  }

  /**
   * v0.18.69 — 从 URL 里读 `?highlight_student={user_id}`
   *
   * ⚛️ 只认**正整数** (非法值当没传) —— 跟本仓其它 URL 参数的解析口径一致。
   */
  readHighlightParam() {
    try {
      const sp = new URLSearchParams(window.location.search || '');
      const raw = sp.get('highlight_student');
      const id = parseInt(raw, 10);
      return Number.isFinite(id) && id > 0 ? id : null;
    } catch (e) {
      return null;
    }
  }

  /** 这一行是不是被高亮的那一个? (判据 = user_id) */
  isHighlighted(s) {
    return !!(this.highlightStudentId && s && Number(s.user_id) === Number(this.highlightStudentId));
  }

  /**
   * v0.18.69 — 高亮**一次性**: 2.5s 后自动摘掉 (brief §4.2)。
   *
   * ⚠️ 计时器**只起一次** (this._highlightTimer 有值就不再起) ——
   *   否则每次 load() 都会重置 2.5s, 高亮就永远摘不掉。
   */
  startHighlightTimer() {
    if (!this.highlightStudentId || this._highlightTimer) return;
    this._highlightTimer = setTimeout(() => {
      this._highlightTimer = null;
      this.highlightStudentId = null;
      m.redraw();
    }, 2500);
  }

  /** 高亮行滚到视野中间 (⚠️ 桌面/移动两套 DOM 都渲染了 ⇒ 必须挑**可见**的那套) */
  scrollHighlightIntoView() {
    if (!this.highlightStudentId) return;
    setTimeout(() => {
      const isMobile = typeof window !== 'undefined' && window.innerWidth <= 640;
      const scope = isMobile ? '.ZS-student-section-mobile' : '.ZS-student-section-desktop';
      const el = document.querySelector(scope + ' .ZS-student-row-highlight');
      if (el && el.scrollIntoView) {
        try {
          el.scrollIntoView({
            block: 'center',
            behavior: 'smooth'
          });
        } catch (e) {
          el.scrollIntoView();
        }
      }
    }, 60);
  }
  async load() {
    try {
      this.loading = true;
      const r = await Api.get('students-list', {
        school_id: this.activeSchoolId,
        filter: this.filter,
        q: this.search
      });
      this.students = r && r.students || [];
      // ── v0.17.24a — 无权限用户的标题 undefined 回归修复 (主防线, 收口在赋值处) ──
      //   改前: `this.stats = (r && r.stats) || this.stats;` —— 后端无权限分支返回的 `stats: []`
      //   在 JS 里是 truthy, `[] || x` ⇒ `[]`, 直接把 oninit 的默认值整个冲掉,
      //   标题 / filterOptions / 5 张统计卡全渲染 undefined。
      //   改后: 一律「默认值 + 合并服务端返回」, 畸形/空的 stats 都冲不掉默认值。
      this.stats = Object.assign({}, STATS_DEFAULTS, r && r.stats || {});
      if (this.students.length > 0) {
        const userIds = this.students.map(s => s.user_id).filter(Boolean);
        Promise.all(userIds.map(uid => app.store.find('users', uid).catch(() => null))).then(() => {
          m.redraw();
        });
      }

      // ── v0.18.69 — 命中高亮的那一行: 起一次性计时器 + 滚到视野中间 ──
      if (this.highlightStudentId && this.students.some(s => Number(s.user_id) === Number(this.highlightStudentId))) {
        this.startHighlightTimer();
        this.scrollHighlightIntoView();
      }
    } catch (e) {
      console.error('load students failed', e);
    } finally {
      this.loading = false;
      m.redraw();
    }
  }
  setFilter(f) {
    this.filter = f;
    this.load();
  }
  openBindCard(student) {
    app.modal.show(BindCardModal, {
      student,
      mode: 'create',
      schools: this.schools,
      activeSchoolId: this.activeSchoolId,
      onClose: () => this.load()
    });
  }
  openExtend(card) {
    app.modal.show(BindCardModal, {
      card,
      mode: 'extend',
      schools: this.schools,
      onClose: () => this.load()
    });
  }
  openActivateCard(card) {
    app.modal.show(ActivateCardModal, {
      card,
      student: this.findStudentByCard(card),
      onClose: () => this.load()
    });
  }
  findStudentByCard(card) {
    if (!card) return null;
    return (this.students || []).find(s => s.id === card.student_id) || null;
  }

  // v0.19.30 — 「添加学员」改两步流程后的**回调透传**
  //   ⚠️ StudentsListTab 是 SchedulerIndexPage 的**子组件** ⇒ 父组件拿不到本组件实例,
  //      不能靠 ref / 事件来回传 ⇒ 只能把「刷新列表」这个回调当参数一层层传下去
  //      (⛔ 不自己造 CustomEvent —— 父子直接传参, 没有跨层的必要)。
  //   onDone = 第 2 步(绑定卡片)成功后由父组件回调 ⇒ 本组件重新 load() 拉数据。
  //   ⚠️ 之前父组件那边只有 m.redraw() ⇒ 本组件的 load() 不会重跑 (它只在 oninit / 切校区时跑)
  //      ⇒ 加完学员列表不刷新, 要刷页面才看得到。onDone 就是来补这个洞的。
  openAddStudent(onDone) {
    if (this.onAddStudentCb) {
      this.onAddStudentCb(onDone); // ← 透传给父组件 (父组件负责弹 modal)
    } else {
      app.modal.show(AddStudentModal, {
        activeSchoolId: this.activeSchoolId,
        schools: this.schools,
        // onDone 本身就是「刷新列表」; 没传就自己 load() (两者等价, 只跑一次, 不重复请求)
        onClose: () => {
          if (onDone) onDone();else this.load();
        }
      });
    }
  }
  openEditStudent(student) {
    app.modal.show(EditStudentModal, {
      student: student,
      activeSchoolId: this.activeSchoolId,
      schools: this.schools || [],
      onClose: () => this.load()
    });
  }
  formatExpires(card) {
    // v0.8.2 — 短格式 (桌面/移动行 3 max-width 156/122, 必须精炼)
    if (!card.expires_at) return null;
    if (card.is_expired) {
      return {
        text: '已过期 ' + Math.abs(card.expires_in_days) + ' 天',
        class: 'red'
      };
    }
    if (card.expires_in_days !== null && card.expires_in_days <= 7) {
      return {
        text: card.expires_in_days + ' 天后过期',
        class: 'orange'
      };
    }
    // 正常 → MM/DD 到期 (YYYY-MM-DD → MM/DD)
    const parts = String(card.expires_at).split('-');
    const short = parts.length === 3 ? parts[1] + '/' + parts[2] : card.expires_at;
    return {
      text: short + ' 到期',
      class: 'green'
    };
  }
  cardClass(card) {
    if (card.is_expired || card.status === 'expired') return 'expired';
    if (card.expires_in_days !== null && card.expires_in_days <= 7) return 'expiring';
    return '';
  }

  // ── v0.18.62 (辉哥 10/23 拍板, 设计稿 v4 · S5) — 退费状态角标 ─────────────
  //
  // ⚠️ **角标只是卡行上的一个状态标记, 不改变卡片本身的版式** (设计稿明文)
  //   ⇒ 这里只**加**一个角标元素 + 两个 class, ⛔ 不动卡行的任何现有结构。
  //
  // ⚠️ 角标状态**只读后端下发的** `card.refund_status` (⛔ 前端不自己判状态):
  //   pending ⇒ 待审批 · approved ⇒ 已退(+金额) · rejected ⇒ 已驳回 · none ⇒ 不渲染

  /** 卡上有没有退费角标 */
  hasRefundBadge(card) {
    const st = card && card.refund_status;
    return !!(st && st !== 'none');
  }

  /** 卡是不是「已退」(卡行整体压暗) */
  isRefundedCard(card) {
    return !!(card && (card.status === 'refunded' || card.refund_status === 'approved'));
  }

  /** 退费状态角标 (⛔ `none` / 空 ⇒ 不渲染) */
  refundBadge(card) {
    const st = card && card.refund_status;
    if (!st || st === 'none') return null;
    if (st === 'pending') {
      return m("span", {
        className: "ZS-refund-badge pending"
      }, m("i", {
        className: "fas fa-hourglass"
      }), "\u5F85\u5BA1\u6279");
    }
    if (st === 'approved') {
      return m("span", {
        className: "ZS-refund-badge refunded"
      }, m("i", {
        className: "fas fa-circle-check"
      }), "\u5DF2\u9000 ", m("span", {
        className: "amt"
      }, "\xA5", formatAmount(card.refund_amount)));
    }
    if (st === 'rejected') {
      return m("span", {
        className: "ZS-refund-badge rejected"
      }, m("i", {
        className: "fas fa-ban"
      }), "\u5DF2\u9A73\u56DE");
    }
    return null;
  }
  filterOptions() {
    return [{
      key: 'all',
      label: '全部',
      count: this.stats.total_students
    }, {
      key: 'valid',
      label: '有效',
      count: this.stats.valid_cards
    }, {
      key: 'expiring',
      label: '即将过期',
      count: this.stats.expiring_cards
    }, {
      key: 'expired',
      label: '有已过期卡',
      count: this.stats.expired_cards
    }, {
      key: 'nocard',
      label: '无卡',
      count: null
    }];
  }
  titleRow() {
    // ── v0.17.24 — BUG-B 口径对齐: 改用 this.stats (后端全量统计) ──
    //   ⚠️ 改前这里是 `this.students.length` + `Σ st.bound_count`, 也就是**当前筛选/搜索后**
    //      的列表 —— 搜一下标题就变, 跟下方统计卡 (this.stats, 后端全量) 永远对不上,
    //      两个数字口径不同。实测改前标题 7 人 vs 统计卡 8 人 (且 8 本身还多算了那张
    //      student_id IS NULL 的体验卡, 后端同一轮已修)。
    //   现在标题与统计卡**同源** (都读 this.stats): 这是「总览标题」, 不受搜索框/筛选按钮
    //   影响; 筛选只改变下面列表显示哪些行, 不改变总量。
    // ── v0.17.24a — 第二道防线: 两个读取点各加一层兜底 (赋值处已在 load() 收口, 这里防
    //   stats 在别处被换成非对象/null 时标题又炸; 主防线仍是 load() 那行 Object.assign) ──
    const total = this.stats?.total_students ?? 0;
    const cards = this.stats?.total_cards ?? 0;
    return m("div", {
      className: "ZS-student-list-title-row"
    }, m("h2", {
      className: "ZS-student-list-title"
    }, app.translator.trans('ziven-scheduler.forum.student-list.title', {
      count: total,
      cards
    })), m("button", {
      className: "ZS-add-student-btn",
      title: app.translator.trans('ziven-scheduler.forum.student-list.add-title'),
      onclick: () => this.openAddStudent(() => this.load())
    }, m("i", {
      className: "fas fa-plus",
      "aria-hidden": "true"
    }), m("span", {
      className: "ZS-add-student-btn-text"
    }, app.translator.trans('ziven-scheduler.forum.student-list.add'))));
  }
  statRow() {
    const stats = [{
      key: 'total',
      icon: 'fa-users',
      iconBg: 'var(--zs-brand-soft-2-45-123-229-015, rgba(45,123,229,0.15))',
      iconColor: 'var(--zs-brand-3b82f6, #3b82f6)',
      label: app.translator.trans('ziven-scheduler.forum.student-list.total-students'),
      value: this.stats.total_students,
      valueColor: 'var(--zs-text-1-e5e7eb, #e5e7eb)'
    }, {
      key: 'total_cards',
      icon: 'fa-ticket',
      iconBg: 'var(--zs-cyan-soft-6-182-212-015, rgba(6,182,212,0.15))',
      iconColor: 'var(--zs-cyan-06b6d4, #06b6d4)',
      label: app.translator.trans('ziven-scheduler.forum.student-list.total-cards'),
      value: this.stats.total_cards,
      valueColor: 'var(--zs-purple-8b5cf6, #8b5cf6)'
    }, {
      key: 'valid',
      icon: 'fa-check',
      iconBg: 'var(--zs-success-soft-16-185-129-015, rgba(16,185,129,0.15))',
      iconColor: 'var(--zs-success-10b981, #10b981)',
      label: app.translator.trans('ziven-scheduler.forum.student-list.valid-cards'),
      value: this.stats.valid_cards,
      valueColor: 'var(--zs-success-10b981, #10b981)'
    }, {
      key: 'expiring',
      icon: 'fa-clock',
      iconBg: 'var(--zs-warning-soft-245-158-11-015, rgba(245,158,11,0.15))',
      iconColor: 'var(--zs-warning-f59e0b, #f59e0b)',
      label: app.translator.trans('ziven-scheduler.forum.student-list.expiring-soon'),
      value: this.stats.expiring_cards,
      valueColor: 'var(--zs-warning-f59e0b, #f59e0b)'
    }, {
      key: 'expired',
      icon: 'fa-triangle-exclamation',
      iconBg: 'var(--zs-danger-soft-239-68-68-015, rgba(239,68,68,0.15))',
      iconColor: 'var(--zs-danger-ef4444, #ef4444)',
      label: app.translator.trans('ziven-scheduler.forum.student-list.expired-cards'),
      value: this.stats.expired_cards,
      valueColor: 'var(--zs-danger-ef4444, #ef4444)'
    }];
    return m('[', null, m("div", {
      className: "ZS-stat-row ZS-stat-row-desktop ZS-stat-row-students"
    }, stats.map(s => m("div", {
      className: "ZS-stat-card",
      key: 'd-' + s.key
    }, m("div", {
      className: "ZS-stat-icon",
      style: 'background:' + s.iconBg + ';color:' + s.iconColor + ';'
    }, m("i", {
      className: 'fas ' + s.icon
    })), m("div", null, m("div", {
      className: "ZS-stat-label"
    }, s.label), m("div", {
      className: "ZS-stat-value",
      style: 'color:' + s.valueColor + ';'
    }, s.value))))), m("div", {
      className: "ZS-stats-scroll-mobile"
    }, stats.map(s => m("div", {
      className: "ZS-stat-pill",
      key: 'm-' + s.key
    }, m("div", {
      className: "ZS-stat-pill-icon",
      style: 'background:' + s.iconBg + ';color:' + s.iconColor + ';'
    }, m("i", {
      className: 'fas ' + s.icon
    })), m("div", null, m("div", {
      className: "ZS-stat-pill-label"
    }, s.label), m("div", {
      className: "ZS-stat-pill-value",
      style: 'color:' + s.valueColor + ';'
    }, s.value))))));
  }
  filterRow() {
    const opts = this.filterOptions();
    const current = opts.find(f => f.key === this.filter) || opts[0];
    return m("div", {
      className: "ZS-student-list-filter-row"
    }, m(Dropdown, {
      buttonClassName: "ZS-filter-dropdown-btn",
      icon: "fas fa-filter",
      label: m("span", {
        className: "ZS-filter-label"
      }, m("span", {
        className: "ZS-filter-label-text"
      }, current.label), current.count !== null && m("span", {
        className: "ZS-filter-label-count"
      }, current.count))
    }, opts.map(f => m(Button, {
      active: this.filter === f.key,
      onclick: () => this.setFilter(f.key),
      key: f.key
    }, m("span", {
      className: "ZS-filter-option-text"
    }, f.label), f.count !== null && m("span", {
      className: "ZS-filter-option-count"
    }, f.count)))), m("div", {
      className: "ZS-search-wrap"
    }, m("i", {
      className: "fas fa-search ZS-search-icon",
      "aria-hidden": "true"
    }), m("input", {
      className: "ZS-search-input",
      placeholder: app.translator.trans('ziven-scheduler.forum.student-list.search-placeholder'),
      value: this.search,
      oninput: e => {
        this.search = e.target.value;
      },
      onkeydown: e => {
        if (e.key === 'Enter') this.load();
      }
    })));
  }

  // v0.8.1 — 浮层在 _popupHTML / _popupShow 里手写 DOM (B 方案: 单例 + body 顶层 + fixed)
  //   popoverButtons / desktopPopoverNode / mobilePopoverNode JSX 已废弃, 删除

  /**
   * v0.10.0 — 合同入口按钮 (桌面行内第 4 个按钮 / 移动端 chip, 两端同一份逻辑)
   *
   * 拍板② 上传入口**只在学员列表** —— 绑卡弹窗一行都不加, 包括只读提示也不加。
   *   本方法是合同入口在本文件的**唯一**出现点, 想加第二个入口都不必改这里。
   *
   * @param {object} s 学员
   * @param {'desktop'|'mobile'} kind
   */
  _contractBtn(s, kind) {
    const n = parseInt(s.contract_count, 10) || 0;
    const has = n > 0;
    const cls = kind === 'mobile' ? 'sc-btn sc-btn-contract' + (has ? ' is-on' : '') : 'action-btn action-btn-contract' + (has ? ' is-on' : '');
    const badge = has ? m("span", {
      className: "ZS-contract-cnt"
    }, n) : null;
    const label = has ? '合同 (' + n + ' 份)' : '合同（暂无）';
    const open = e => {
      if (e) {
        e.stopPropagation();
      }
      // v0.10.7 — 原生 Modal 居中显示, 不再需要锚点元素定位, 第二个参数已删除
      this.openContracts(s);
    };
    if (kind === 'mobile') {
      return m("button", {
        className: cls,
        title: label,
        onclick: open
      }, m("i", {
        className: "fas fa-paperclip",
        "aria-hidden": "true"
      }), "\u5408\u540C", badge);
    }
    return m("button", {
      className: cls,
      title: label,
      "aria-label": label,
      onclick: open
    }, m("i", {
      className: "fas fa-paperclip",
      "aria-hidden": "true"
    }), badge);
  }

  /** v0.10.7 — 打开合同 Modal (Flarum 原生, 跟 CardDetailModal/BindCardModal 同一套用法) */
  openContracts(s) {
    if (!this.activeSchoolId) {
      SlotContextMenu.toast('请先选择校区', 'error');
      return;
    }
    // 上传/改名/删除后回调: 只更新该学员的角标, 不整表 reload
    //
    // ⚠️ 重绘用组件别处已经在用的全局 `m.redraw()` (Flarum bundle 提供的全局, 见本文件 load()),
    //    **不是** `this.app.forceUpdate()` —— Component 上没有 this.app, 调它会抛
    //    TypeError, 而这个回调是在 modal 的 then() 里跑的。
    app.modal.show(StudentContractModal, {
      student: s,
      schoolId: this.activeSchoolId,
      onChanged: newCount => {
        if (typeof newCount === 'number') {
          const target = (this.students || []).find(x => x.user_id === s.user_id);
          if (target) {
            target.contract_count = newCount;
          }
        }
        if (typeof m !== 'undefined' && m && typeof m.redraw === 'function') m.redraw();
      }
    });
    this._contractModalOpen = true;
  }

  /**
   * v0.17.14 — 打开「上课详情」Modal (Flarum 原生, 跟 StudentContractModal/CardDetailModal 同一套用法)
   *
   * 桌面 (行内第 3 个按钮, 原 fa-eye 死按钮) 与移动 (.sc-actions 第 3 个 chip) 共用这一个入口。
   * 弹层只读: 课次从 lessons 端点按 student_id 拉, 后端已支持该过滤且默认 start_at desc,
   * 所以这里不传排序、不传状态过滤 —— 全部课次原样摊开, 由弹层自己分桶统计。
   */
  openStudentLessons(s) {
    if (!this.activeSchoolId) {
      SlotContextMenu.toast('请先选择校区', 'error');
      return;
    }
    app.modal.show(StudentLessonsModal, {
      student: s,
      schoolId: this.activeSchoolId
    });
  }
  desktopRow(s) {
    return /* v0.18.69 — 「查看学员」跳过来的那一行加一次性高亮 (2.5s 后自动摘掉) */m("div", {
      className: 'ZS-student-row' + (this.isHighlighted(s) ? ' ZS-student-row-highlight' : ''),
      key: s.id
    }, m("div", {
      className: "ZS-student-row-1"
    }, m("div", {
      className: "ZS-student-info"
    }, m(UserAvatarLink, {
      userId: s.user_id
    }), m("div", {
      className: "ZS-student-meta"
    }, m("div", {
      className: "ZS-student-name"
    }, s.nickname && m("span", {
      className: "ZS-student-nickname"
    }, s.nickname), s.nickname && m("span", {
      className: "ZS-student-at"
    }, " @ "), m(UserNameLink, {
      userId: s.user_id
    }), s.bound_count > 0 && m("span", {
      className: "count-badge"
    }, s.bound_count, " \u5361")), m("div", {
      className: "ZS-student-contact"
    }, s.phone && m("span", {
      className: "ZS-student-phone-item"
    }, m("i", {
      className: "fas fa-phone",
      "aria-hidden": "true"
    }), ' ', s.phone), s.email && m("span", {
      className: "ZS-student-email-item"
    }, m("i", {
      className: "fas fa-envelope",
      "aria-hidden": "true"
    }), ' ', s.email)))), m("div", {
      className: "ZS-student-summary"
    }, m("div", {
      className: "ZS-student-count"
    }, m("span", {
      className: "count-value"
    }, s.bound_count), m("span", {
      className: "count-label"
    }, "\u5F20\u5361")), m("div", {
      className: "ZS-student-amount"
    }, "\xA5 ", s.total_spent.toLocaleString()), m("div", {
      className: "ZS-student-actions"
    }, m("button", {
      className: "action-btn action-btn-bind",
      title: "\u7ED1\u5361",
      "aria-label": "\u7ED1\u5361",
      onclick: () => this.openBindCard(s)
    }, m("i", {
      className: "fas fa-plus",
      "aria-hidden": "true"
    })), m("button", {
      className: "action-btn",
      title: app.translator.trans('ziven-scheduler.forum.student-list.edit-title'),
      "aria-label": "\u7F16\u8F91",
      onclick: () => this.openEditStudent(s)
    }, m("i", {
      className: "fas fa-pen",
      "aria-hidden": "true"
    })), m("button", {
      className: "action-btn action-btn-lessons",
      title: "\u4E0A\u8BFE\u8BE6\u60C5",
      "aria-label": "\u4E0A\u8BFE\u8BE6\u60C5",
      onclick: () => this.openStudentLessons(s)
    }, m("i", {
      className: "fas fa-eye",
      "aria-hidden": "true"
    })), this._contractBtn(s, 'desktop')))), m("div", {
      className: "ZS-cards-stack"
    }, s.cards.map(card => {
      const cls = this.cardClass(card);
      const exp = this.formatExpires(card);
      const mainAct = card.is_activated === false ? 'activate' : card.is_expired ? 'unlock' : 'extend';
      const mainLabel = mainAct === 'activate' ? '开卡' : mainAct === 'unlock' ? '延期解锁' : '延期';
      return m("div", {
        key: card.id,
        className: 'ZS-card-item ' + cls + (card.bg_image ? ' has-bg' : '') + (this.hasRefundBadge(card) ? ' has-refund-badge' : '') + (this.isRefundedCard(card) ? ' refunded' : ''),
        "data-card-id": card.id,
        style: cardBackgroundStyle(card.bg_image),
        onclick: e => e.stopPropagation()
      }, m("div", {
        className: "card-info"
      }, m("div", {
        className: "card-name"
      }, card.template_name || `学员卡 #${card.id}`, card.is_expired && m("span", {
        style: "margin-left:8px;"
      }, m("i", {
        className: "fas fa-lock",
        style: "color:var(--zs-cyan-06b6d4, #06b6d4);"
      }))), m("div", {
        className: 'card-remaining' + (this.isUnlimited(card) ? ' unlimited' : '') + (!this.isUnlimited(card) && card.remaining_lessons <= 0 ? ' empty' : '')
      }, this.isUnlimited(card) ? '不限次' : m('[', null, m("span", {
        className: "num-now"
      }, card.remaining_lessons), m("span", {
        className: "sep"
      }, "/"), m("span", {
        className: "num-total"
      }, card.total_lessons), " \u8BFE\u65F6")), exp && m("span", {
        className: 'card-expire-tag ' + exp.class
      }, exp.text)), this.refundBadge(card), m("div", {
        className: "card-actions"
      }, m("button", {
        className: "__act-btn",
        title: "\u8BE6\u60C5",
        "aria-label": "\u8BE6\u60C5",
        onclick: e => {
          e.stopPropagation();
          this._popupButtonClick('detail', card);
        }
      }, m("i", {
        className: "fas fa-circle-info",
        "aria-hidden": "true"
      })), m("button", {
        className: "__act-btn __act-primary",
        title: mainLabel,
        "aria-label": mainLabel,
        onclick: e => {
          e.stopPropagation();
          this._popupButtonClick(mainAct, card);
        }
      }, m("i", {
        className: "fas fa-bolt",
        "aria-hidden": "true"
      }), m("span", {
        className: "act-lbl"
      }, mainLabel))));
    })));
  }
  emptyState() {
    return m("div", {
      style: "padding:60px;text-align:center;color:var(--zs-text-2-9ca3af, #9ca3af);"
    }, "\u6682\u65E0\u5B66\u5458\u6570\u636E");
  }

  // v0.8.1 — 检测 .sc-cards 是否需要横滑 (scrollWidth > clientWidth → 加 .has-overflow)
  updateScCardsOverflow(el) {
    if (!el) return;
    if (el.scrollWidth > el.clientWidth + 1) {
      el.classList.add('has-overflow');
    } else {
      el.classList.remove('has-overflow');
    }
  }
  _installOverflowResize() {
    if (this._overflowResizeHandler) return;
    this._overflowResizeHandler = () => {
      if (!this.element) return;
      this.element.querySelectorAll('.sc-cards').forEach(sc => this.updateScCardsOverflow(sc));
    };
    window.addEventListener('resize', this._overflowResizeHandler);
  }
  mobileRow(s) {
    return /* v0.18.69 — 「查看学员」跳过来的那一行加一次性高亮 (2.5s 后自动摘掉) */m("div", {
      className: 'ZS-student-card-mobile' + (this.isHighlighted(s) ? ' ZS-student-row-highlight' : ''),
      key: 'm-' + s.id
    }, m("div", {
      className: "sc-head"
    }, m(UserAvatarLink, {
      userId: s.user_id
    }), m("div", {
      className: "sc-info"
    }, m("div", {
      className: "sc-name"
    }, s.nickname && m("span", {
      className: "sc-nickname"
    }, s.nickname), s.nickname && m("span", {
      className: "sc-at"
    }, " @"), m(UserNameLink, {
      userId: s.user_id
    }), s.bound_count > 0 && m("span", {
      className: "sc-badge"
    }, s.bound_count, " \u5361")), m("div", {
      className: "sc-contact"
    }, s.phone && m("span", {
      className: "sc-phone-item"
    }, m("i", {
      className: "fas fa-phone",
      "aria-hidden": "true"
    }), ' ', m("a", {
      href: "tel:" + s.phone
    }, s.phone)), !s.phone && s.email && m("span", {
      className: "sc-email-item"
    }, m("i", {
      className: "fas fa-envelope",
      "aria-hidden": "true"
    }), ' ', s.email))), m("div", {
      className: "sc-spent"
    }, m("div", {
      className: "lbl"
    }, "\u603B\u6D88\u8D39"), m("div", {
      className: "val"
    }, "\xA5 ", s.total_spent.toLocaleString()))), s.cards.length > 0 && m("div", {
      className: "sc-cards",
      oncreate: vnode => {
        const el = vnode.dom;
        requestAnimationFrame(() => this.updateScCardsOverflow(el));
        this._installOverflowResize();
      },
      onupdate: vnode => {
        const el = vnode.dom;
        requestAnimationFrame(() => this.updateScCardsOverflow(el));
      }
    }, s.cards.map(card => {
      const cls = this.cardClass(card);
      const exp = this.formatExpires(card);
      const mainAct = card.is_activated === false ? 'activate' : card.is_expired ? 'unlock' : 'extend';
      const mainLabel = mainAct === 'activate' ? '开卡' : mainAct === 'unlock' ? '延期解锁' : '延期';
      return m("div", {
        key: card.id,
        className: 'sc-card ' + cls + (card.bg_image ? ' has-bg' : '') + (this.hasRefundBadge(card) ? ' has-refund-badge' : '') + (this.isRefundedCard(card) ? ' refunded' : ''),
        "data-card-id": card.id,
        style: cardBackgroundStyle(card.bg_image),
        onclick: e => e.stopPropagation()
      }, m("div", {
        className: "head"
      }, m("div", {
        className: "name"
      }, card.template_name || `学员卡 #${card.id}`), m("div", {
        className: 'lessons' + (this.isUnlimited(card) ? ' unlimited' : '') + (!this.isUnlimited(card) && card.remaining_lessons <= 0 ? ' empty' : '')
      }, this.isUnlimited(card) ? '不限次' : m('[', null, m("span", {
        className: "num-now"
      }, card.remaining_lessons), m("span", {
        className: "sep"
      }, "/"), m("span", {
        className: "num-total"
      }, card.total_lessons), "\u8BFE\u65F6")), exp && m("div", {
        className: 'exp ' + exp.class
      }, exp.text)), this.refundBadge(card), m("div", {
        className: "__actions"
      }, m("button", {
        className: "__act-btn",
        title: "\u8BE6\u60C5",
        "aria-label": "\u8BE6\u60C5",
        onclick: e => {
          e.stopPropagation();
          this._popupButtonClick('detail', card);
        }
      }, m("i", {
        className: "fas fa-circle-info",
        "aria-hidden": "true"
      })), m("button", {
        className: "__act-btn __act-primary",
        title: mainLabel,
        "aria-label": mainLabel,
        onclick: e => {
          e.stopPropagation();
          this._popupButtonClick(mainAct, card);
        }
      }, m("i", {
        className: "fas fa-bolt",
        "aria-hidden": "true"
      }), m("span", {
        className: "act-lbl"
      }, mainLabel)), m("button", {
        className: "__act-btn",
        title: "\u66F4\u591A",
        "aria-label": "\u66F4\u591A",
        onclick: e => {
          e.stopPropagation();
          this._popupButtonClick('detail', card);
        }
      }, m("i", {
        className: "fas fa-ellipsis-vertical",
        "aria-hidden": "true"
      }))));
    }), m("div", {
      className: "sc-cards-fade"
    })), m("div", {
      className: "sc-actions"
    }, m("button", {
      className: "sc-btn sc-btn-bind-inline",
      onclick: () => this.openBindCard(s)
    }, "\u7ED1\u5361"), m("button", {
      className: "sc-btn",
      title: "\u7F16\u8F91",
      onclick: () => this.openEditStudent(s)
    }, m("i", {
      className: "fas fa-note-sticky",
      style: "color:var(--zs-cyan-06b6d4, #06b6d4);margin-right:4px;"
    }), "\u7F16\u8F91"), m("button", {
      className: "sc-btn sc-btn-lessons",
      title: "\u4E0A\u8BFE\u8BE6\u60C5",
      onclick: () => this.openStudentLessons(s)
    }, "\u4E0A\u8BFE\u8BE6\u60C5"), this._contractBtn(s, 'mobile')));
  }
  view() {
    return m("div", {
      className: "ZS-student-list-root"
    }, this.titleRow(), this.statRow(), this.filterRow(), this.loading ? m("div", {
      style: "padding:60px;text-align:center;color:var(--zs-text-2-9ca3af, #9ca3af);"
    }, "\u52A0\u8F7D\u4E2D...") : m('[', null, m("div", {
      className: "ZS-student-section ZS-student-section-desktop"
    }, this.students.length === 0 ? this.emptyState() : this.students.map(s => this.desktopRow(s))), m("div", {
      className: "ZS-student-section-mobile"
    }, this.students.length === 0 ? this.emptyState() : this.students.map(s => this.mobileRow(s)))));
  }
}
flarum.reg.add('ziiven-ziven-scheduler', 'forum/components/StudentsListTab', StudentsListTab);